import { useRef } from "react";

// Components
import ContentContainer from "../../../layouts/ContentContainer/ContentContainer";
import NavBar from "../../../components/NavBar/NavBar";
import Banner from "../../../layouts/Banner/Banner";
import EmbedVideo from "../../../components/VideoContainer/EmbedVideo";

// Buttons
import ScrollToTopButton from "../../../components/Buttons/ScrollToTopButton";
// Assets
import cornerDecor from "../../../assets/imgs/join-us-page/Henry.svg";
// Custom hook

const Join = () => {
   const pageRef = useRef(null);
   return (
      <div
         ref={pageRef}
         className="page page-book base-page-culture page--font-dark"
      >
         <div className="page__inner">
            <header id="page-three-top" className="header">
               <div className="background-image--join"></div>
               <NavBar />
               <div className="hero">
                  <div className="hero__container">
                     <EmbedVideo videoCode="refq2o7hp4" embedType="wistia" />
                     <div className="hero__text">
                        <p className="hero__paragraph">
                           I feel right at home in Avado!
                        </p>
                     </div>
                  </div>
               </div>
            </header>

            <main>
               <ContentContainer modifier="gapless-bottom">
                  <div className="text-container--2col">
                     <h1 className="heading heading--primary">Joining us</h1>
                     <h3 className="heading heading--tertiary">
                        Pay and personal information
                     </h3>
                     <p>
                        Details of payment terms can be found in your offer
                        letter and your contract of employment.
                     </p>
                     <p>
                        To make sure you’re correctly set up on our payroll
                        system, we will need the following information from you
                        either on or before your first day:
                     </p>
                     <ul className="paragraph paragraph__list paragraph__list--highlight">
                        <li>Bank account details</li>
                        <li>Home address</li>
                        <li>Next of kin/emergency contact</li>
                        <li>Personal email address</li>
                        <li>National Insurance / Social Security Number</li>
                     </ul>
                     <p className="paragraph">
                        If you have any questions about your pay or personal
                        information, please speak to your line manager.
                     </p>
                     <h3 className="heading heading--tertiary">
                        Days 1–90 – The first day
                     </h3>
                     <ul className="paragraph paragraph__list paragraph__list--highlight">
                        <li>
                           Key health and safety Information (including home
                           work set up and key office information)
                        </li>
                        <li>Setting up of your tech equipment</li>
                        <li>
                           Submitting requests for your specific working style;
                           for example, an ergonomic chair or additional
                           computer screen for your remote workspace
                        </li>
                        <li>
                           Speaking with your new line manager about the scope
                           and responsibilities of your role
                        </li>
                        <li>Signposting key information</li>
                     </ul>
                  </div>
               </ContentContainer>

               <div className="banner banner--start">
                  <Banner
                     modifier="banner-join"
                     styleClass="content-container__container--2col"
                  >
                     <div className="text-container--bg-none">
                        <p className="banner-text">
                           Please remember to have your proof of eligibility to
                           work in the country in which you are employed – this
                           is a legal requirement. Don’t worry, we won’t show
                           anyone your passport photo!
                        </p>
                     </div>
                     <div></div>
                  </Banner>
               </div>

               <ContentContainer>
                  <div className="text-container--2col">
                     <h3 className="heading heading--tertiary">
                        Days 1–90 – First weeks
                     </h3>
                     <p>During your first week you might:</p>
                     <ul className="paragraph paragraph__list paragraph__list--highlight">
                        <li>Ask lots of questions and get stuck in!</li>
                        <li>
                           Sign up for our 'Asana Experts' training and upskill
                           on the job
                        </li>
                        <li>
                           Join any of our Teams channels or sign up for one or
                           more of our virtual social experiences
                        </li>
                        <li>
                           Enrol and arrange an onboarding coaching session with
                           one of our Bravely coaches
                        </li>
                     </ul>
                     <p>In the second week you could find yourself:</p>
                     <ul className="paragraph paragraph__list paragraph__list--highlight">
                        <li>
                           Working from our office space for a change of scene
                           (and free hot drinks)
                        </li>
                        <li>
                           Learning a colleague’s preferred name (or sharing
                           yours!)
                        </li>
                        <li>
                           Learning more about our company OKRs, and where yours
                           are likely to fit into ‘the bigger picture’
                        </li>
                        <li>
                           Working again with a coach from Bravely on your
                           onboarding thoughts, reflections and observations
                        </li>
                     </ul>
                  </div>
               </ContentContainer>

               <ContentContainer>
                  <div className="text-container--2col">
                     <h3 className="heading heading--tertiary">
                        Days 1–90 Your SIP (Settling-In Process)
                     </h3>
                     <p>Settling In Process</p>
                     <p>
                        You will have noticed that your contract does not
                        include a ‘probation period’ (and with good reason).
                        Instead we use a SIP (settling-in process); we much
                        prefer to help people settle than keep them on-edge for
                        12 weeks after they’ve joined.
                     </p>
                     <p>Key differences of a SIP are:</p>
                     <p>
                        From the very start you’ll be involved in your own
                        development – collaborating with your line manager to
                        define and set your personal goals and OKRs (Objectives
                        & Key Results)
                     </p>
                     <p>Your week three might look something like this:</p>
                     <ul className="paragraph paragraph__list text-margin-top">
                        <li>
                           Recognising a colleague in an appropriate way, for
                           helping you get settled
                        </li>
                        <li>
                           Arranging a virtual 'water cooler' break over Teams
                           with a colleague you haven't met yet, or signing up
                           for a ‘coffee roulette’ to meet with a new and
                           different colleague every fortnight hereafter
                        </li>
                        <li>
                           Continuing your work with a coach from Bravely on
                           your approach to your onboarding process
                        </li>
                     </ul>
                     <ul className="paragraph paragraph__list text-margin-top">
                        <div className="corner-image">
                           <img src={cornerDecor} alt="" />
                        </div>
                        <li>
                           Your first three months of employment are for you to
                           explore working life at Avado and begin to add your
                           unique flair to the team. We respect your learning
                           curve and will support you to succeed.
                        </li>
                        <li>
                           We encourage you to reach out to colleagues if there
                           is something you don’t understand. Learning is a
                           journey best travelled together!
                        </li>
                     </ul>
                     <p>
                        Yes, the SIP is also designed to help both you and Avado
                        work out whether this is the right role, environment and
                        opportunity for you. We just like to make sure that it’s
                        an open, liberating experience for you in which to do
                        just that.
                     </p>
                     <p>
                        Our People Experience Team (PX team) have more details
                        on this aspect of your contract{" "}
                     </p>
                  </div>
               </ContentContainer>
               <ContentContainer>
                  <ScrollToTopButton parentContainer={pageRef} />
               </ContentContainer>
            </main>
         </div>
      </div>
   );
};

export default Join;
